import { isEmpty, isNumber, omit } from "lodash";
import {
  PREVIEW_TEXT_MAX_LENGTH,
  SUBJECT_MAX_LENGTH,
} from "@circle-react/components/SettingsApp/Emails/components/Builder/constants";
import { awardPoints } from "@circle-react/components/SettingsApp/Workflows/components/Actions/Gamification/awardPoints";
import { hidePostFromFeaturedAreas } from "../Actions/AiAgents/hidePostFromFeaturedAreas/hidePostFromFeaturedAreas";
import { postComment } from "../Actions/AiAgents/postComment/postComment";
import { reportComment } from "../Actions/AiAgents/reportComment/reportComment";
import { reportPost } from "../Actions/AiAgents/reportPost/reportPost";
import { sendDM as aiAgentsSendDM } from "../Actions/AiAgents/sendDM/sendDM";
import { timeDelay } from "../Actions/Flow/TimeDelay";
import {
  disableMessaging,
  enableMessaging,
  removeMember,
  sendDM,
  sendEmail,
  sendPushNotification,
  unsubscribe,
} from "../Actions/Member";
import { subscribeToPaywallTrial } from "../Actions/Paywall";
import { sendToWebhook } from "../Actions/Webhook";
import { hasTruthyValues } from "./hasTruthyValues";

export const getActionHasValue = (
  action = {},
  isAiAutomationsV2Enabled = false,
) => {
  const { action_type = "", api_params = {} } = action;

  if (action_type === sendEmail.value) {
    return getSendEmailHasValue(api_params);
  }

  if (action_type === sendDM.value) {
    return getSendDmHasValue(api_params);
  }

  if (
    action_type === removeMember.value ||
    action_type === enableMessaging.value ||
    action_type === disableMessaging.value ||
    action_type === unsubscribe.value ||
    action_type === reportPost.value ||
    action_type === reportComment.value
  ) {
    return true;
  }

  if (action_type === sendPushNotification.value) {
    return bodyContentHasValue(api_params?.message?.body?.content);
  }

  if (action_type === sendToWebhook.value) {
    return hasTruthyValues(api_params?.url);
  }

  if (action_type === subscribeToPaywallTrial.value) {
    return hasTruthyValues(
      omit(api_params, "send_notification_subscription_created_by_admin"),
    );
  }

  if (action_type === timeDelay.value) {
    return hasTruthyValues(omit(api_params, "time_delay"));
  }

  if (action_type === awardPoints.value) {
    return hasTruthyValues(api_params?.points);
  }

  if (
    action_type === postComment.value ||
    action_type === aiAgentsSendDM.value
  ) {
    return isNumber(api_params?.community_bot_profile_id);
  }

  if (action_type === hidePostFromFeaturedAreas.value) {
    return getHidePostFromFeaturedAreasHasValue(
      isAiAutomationsV2Enabled,
      api_params,
    );
  }

  return hasTruthyValues(api_params);
};

const getSendEmailHasValue = (params = null) => {
  const currentParams = params || {};
  if (
    !currentParams.internal_name ||
    !currentParams.subject ||
    !currentParams.broadcast_id
  ) {
    return false;
  }
  if (
    currentParams.subject.length > SUBJECT_MAX_LENGTH ||
    currentParams.preview_text?.length > PREVIEW_TEXT_MAX_LENGTH ||
    (isEmpty(currentParams.email_content) &&
      isEmpty(currentParams.visual_email_builder_content))
  ) {
    return false;
  }

  return (
    !isEmpty(currentParams?.email_content?.body.content) ||
    !isEmpty(currentParams?.visual_email_builder_content)
  );
};

const getSendDmHasValue = (params = {}) => {
  if (!isNumber(params?.from) || isEmpty(params?.rich_text_body)) {
    return false;
  }

  return bodyContentHasValue(params?.rich_text_body?.body?.content);
};

const bodyContentHasValue = (bodyContent = []) => {
  if (isEmpty(bodyContent)) return false;

  return bodyContent.some((value = {}) => {
    const { type = "", content = [], text = "" } = value;

    if (type === "text") {
      return !isEmpty(text);
    }

    if (type === "paragraph") {
      return content.some((value = {}) => {
        const { text = "" } = value;
        return !isEmpty(text);
      });
    }
  });
};

const getHidePostFromFeaturedAreasHasValue = (
  isAiAutomationsV2Enabled,
  params = {},
) => {
  if (!isAiAutomationsV2Enabled) {
    return isNumber(params?.community_bot_profile_id);
  }
  return (
    params?.hide_post_from_featured_areas ||
    params?.close_comments ||
    params?.hide_metadata
  );
};
